(function ($) {
	$(document).ready(function () {
		// console.log('forms.js is loading');
		//no enter key form submission
		$(
			'#application-form, #insurance-certificate-form, #loss-control-form, #member-expense-form, #supervisor-accident-form, #workers-comp-form',
		).on('keyup keypress', function (e) {
			var keyCode = e.keyCode || e.which;
			if (keyCode === 13) {
				e.preventDefault();
				return false;
			}
		});

		$('.forms-message-close, .thank-you-message-close').click(function (e) {
			// console.log('clicking close thx message');
			//$('.forms-message').fadeToggle('fast');

			//clear params for AAR & Travel Expense && user registration
			var submitted = urlParam()['form'];
			var user_reg = urlParam()['reg'];
			if (submitted || user_reg) {
				var url = window.location.href;
				var new_url = url.substring(0, url.indexOf('?'));
				window.location.href = new_url;
			} else {
				location.reload();
			}
		});

		$('.md-request-change').click(function (e) {
			$('#member-data-change').fadeToggle();
			$(this).fadeToggle();
		});

		$('#loss_control_attachments').on('change', prepareUpload);

		$('.meal-expenses-table').on('change', '.meal-receipt', expenseFiles);
		$('.lodging-expenses-table').on('change', '.lodging-receipt', expenseFiles);
		$('.parking-expenses-table').on('change', '.parking-receipt', expenseFiles);

		clearAttachment();
		memberDataForm();
		memberDataChange();
		memberExpenses();
	});

	$(window).load(function () {
		showSubmitted();
		quoteMessage();
		regMessage();
		if ($('.forms-message').length > 0) {
			if ($('.forms-message').css('display') !== 'block') {
				$('body').focus();
			} else if ($('.forms-message').css('display') === 'block') {
				trapFocus('.forms-message');
				$('.forms-message-close').focus();
				$(document).on('keyup', function (e) {
					// Close modal on Escape key
					if (e.key === 'Escape' || e.keyCode === 27) {
						$('.forms-message-close').click();
					}
				});
			}
		}
	});

	// Traps focus within the success message modal
	function trapFocus(modalSelector) {
		const modal = document.querySelector(modalSelector);
		if (!modal) return;

		const focusableElements = modal.querySelectorAll(
			'button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])',
		);
		const firstFocusable = focusableElements[0];
		const lastFocusable = focusableElements[focusableElements.length - 1];

		modal.addEventListener('keydown', function (e) {
			if (e.key === 'Tab' || e.keyCode === 9) {
				if (e.shiftKey) {
					// Shift + Tab
					if (document.activeElement === firstFocusable) {
						e.preventDefault();
						lastFocusable.focus();
					}
				} else {
					// Tab
					if (document.activeElement === lastFocusable) {
						e.preventDefault();
						firstFocusable.focus();
					}
				}
			}
		});
	}

	$(window).resize(function () {});

	//functions
	function expenseFiles(event) {
		var files = event.target.files;
		var expense_type = $(this).attr('class');
		var expense_name = $(this).attr('name');
		// console.log(files);
		// console.log(expense_type);

		var fdata = new FormData();

		$.each(files, function (key, value) {
			fdata.append(key, files[key]);
			fdata.append(key, expense_type);
		});

		fdata.append('action', 'travel_files');

		jQuery.ajax({
			type: 'POST',
			url: '/wp-admin/admin-ajax.php',
			data: fdata,
			cache: false,
			processData: false,
			contentType: false,
			success: function (data) {
				// console.log(data);
				var res = $.parseJSON(data);
				// console.log(res);

				if (expense_type == 'meal-receipt') {
					$('#member-expense-form').append(
						'<input type="hidden" class="meal-receipt-attachment" name="' +
							expense_name +
							'" value="' +
							res.file_path +
							'" data-link="' +
							res.file_path +
							'">',
					);
				} else if (expense_type == 'lodging-receipt') {
					$('#member-expense-form').append(
						'<input type="hidden" class="lodging-receipt-attachment" name="' +
							expense_name +
							'" value="' +
							res.file_path +
							'" data-link="' +
							res.file_path +
							'">',
					);
				} else {
					$('#member-expense-form').append(
						'<input type="hidden" class="parking-receipt-attachment" name="' +
							expense_name +
							'" value="' +
							res.file_path +
							'" data-link="' +
							res.file_path +
							'">',
					);
				}
			},
			error: function (error) {
				var err = JSON.stringify(error);
				console.log('there has been an error: ' + err);
			},
		});
	}

	function memberExpenses() {
		$('#mem_exp_entity').on('input', filterMembers);

		$('.travel-typed-results').on('click', '.one-typed-result', function (e) {
			var id = $(this).data('id');
			var name = $(this).text();
			e.preventDefault();
			$('.travel-filter-mem-id').val(id);
			$('#mem_exp_entity').val(name);
			$('.typed-results').css('display', 'none');
		});

		var count = 1;
		$('.add-meal-row').on('click', function (e) {
			e.preventDefault();
			$('.datepicker').datepicker('destroy');
			count++;
			//console.log(count);
			$('.meal-expenses-table tr:last').before(
				'<tr><td><input class="meal-receipt" type="file" name="meal-receipt-' +
					count +
					'" name="meal_attachment[receipt]" accept=".jpg, .jpeg, .png"></td><td><input type="text" class="datepicker" name="meal-date-' +
					count +
					'"></td><td><input type="text" name="meal-restaurant-' +
					count +
					'"></td><td><input type="text" name="meal-location-' +
					count +
					'"></td><td><input class="meal-amount" type="text" name="meal-amount-' +
					count +
					'"></td></tr>',
			);
			$('.datepicker').datepicker();
			$('input[name="count-meal-expenses"]').val(count);
			$('.meal-expenses-table tr:last').prev().find('input:first').focus();
		});
		var rows = 1;
		$('.add-lodging-row').on('click', function (e) {
			e.preventDefault();
			$('.datepicker').datepicker('destroy');
			rows++;
			//console.log(rows);
			$('.lodging-expenses-table tr:last').before(
				'<tr><td><input class="lodging-receipt" type="file" name="lodging-receipt-' +
					rows +
					'" name="lodging_attachment[receipt]" accept=".jpg, .jpeg, .png"></td><td><input type="text" class="datepicker" name="lodging-date-' +
					rows +
					'"></td><td><input type="text" name="lodging-hotel-' +
					rows +
					'"></td><td><input type="text" name="lodging-location-' +
					rows +
					'"></td><td><input class="lodging-amount" type="text" name="lodging-amount-' +
					rows +
					'"></td></tr>',
			);
			$('.datepicker').datepicker();
			$('input[name="count-lodging-expenses"]').val(rows);
			$('.lodging-expenses-table tr:last').prev().find('input:first').focus();
		});
		var p_rows = 1;
		$('.add-parking-row').on('click', function (e) {
			e.preventDefault();
			p_rows++;
			//console.log(p_rows);
			$('.parking-expenses-table tr:last').before(
				'<tr><td colspan="8"><input class="parking-receipt" type="file" name="parking-receipt-' +
					p_rows +
					'" name="parking_attachment[receipt]" accept=".jpg, .jpeg, .png"></td><td colspan="1"><input class="parking-amount" type="text" name="parking-amount-' +
					p_rows +
					'"></td></tr>',
			);
			$('input[name="count-parking-expenses"]').val(p_rows);
			$('.parking-expenses-table tr:last').prev().find('input:first').focus();
		});

		//adding meal amounts
		$('.meal-expenses-table').on('change', function () {
			var total = 0;
			$('.meal-expenses-table')
				.find('.meal-amount')
				.each(function (i, n) {
					var amount = parseFloat($(this).val());
					total += amount;
				});

			var fixedtotal = total.toFixed(2);
			//var newamount = (isNaN(fixedtotal)? 0 : fixedtotal);
			$('input[name="meal_total"]').val(fixedtotal);
		});

		//adding lodging amounts
		$('.lodging-expenses-table').on('change', function () {
			var total = 0;
			$('.lodging-expenses-table')
				.find('.lodging-amount')
				.each(function (i, n) {
					var amount = parseFloat($(this).val());
					total += amount;
				});

			var fixedtotal = total.toFixed(2);
			$('input[name="lodging_total"]').val(fixedtotal);
		});

		//adding parking amounts
		$('.parking-expenses-table').on('change', function () {
			var total = 0;
			$('.parking-expenses-table')
				.find('.parking-amount')
				.each(function (i, n) {
					var amount = parseFloat($(this).val());
					total += amount;
				});

			var fixedtotal = total.toFixed(2);
			$('input[name="parking_total"]').val(fixedtotal);
		});

		//mileage multiplier
		$('input[name="round_trip_miles"], input[name="mileage_rate"]').bind(
			'change',
			function () {
				var totmiles = $('input[name="round_trip_miles"]');
				var rate = $('input[name="mileage_rate"]');
				if (!totmiles.val()) {
					var t = 0;
				} else {
					var t = parseFloat(totmiles.val());
				}

				if (!rate.val()) {
					var r = 0;
				} else {
					var r = parseFloat(rate.val());
				}

				var sum = t * r;
				var fixedsum = sum.toFixed(2);
				$('input[name="mileage_reimbursement"]').val(fixedsum);
			},
		);

		//add values from A B C D
		$(
			'.meal-expenses-table, .lodging-expenses-table, .automobile-expenses-table, .parking-expenses-table',
		).bind('change', function () {
			var meal = $('input[name="meal_total"');
			var lodging = $('input[name="lodging_total"]');
			var miles = $('input[name="mileage_reimbursement"]');
			var parking = $('input[name="parking_total"]');
			if (!meal.val()) {
				var m = 0;
			} else {
				var m = parseFloat(meal.val());
			}

			if (!lodging.val()) {
				var l = 0;
			} else {
				var l = parseFloat(lodging.val());
			}

			if (!miles.val()) {
				var mi = 0;
			} else {
				var mi = parseFloat(miles.val());
			}

			if (!parking.val()) {
				var p = 0;
			} else {
				var p = parseFloat(parking.val());
			}

			var sum = m + l + mi + p;
			var fixedsum = sum.toFixed(2);
			$('input[name="total_reimbursement"]').val(fixedsum);
		});
	}

	function filterMembers(event) {
		// console.log( $(this).val() );
		var name = $(this).val();

		jQuery.ajax({
			type: 'POST',
			url: '/wp-admin/admin-ajax.php',
			data: {
				action: 'type_member',
				value: name,
			},
			success: function (response) {
				// console.log('from 145', response);

				var res = $.parseJSON(response);
				// console.log(res);
				$('.typed-results').html('');
				if (res.length == 0) {
					$('.typed-results').css('display', 'none');
				} else {
					$('.typed-results').css('display', 'block');
				}
				$.map(res, function (value, index) {
					//console.log(value.mem_id + ' : ' + value.name);
					$('.typed-results').append(
						'<a class="one-typed-result" data-id="' +
							value.mem_id +
							'" role="button">' +
							value.name +
							'</a>',
					);
				});
				if (res.length == 0) {
					$('.typed-results').css('display', 'none');
				}
			},
		});
	}

	function urlParam() {
		var vars = [],
			hash;
		var hashes = window.location.href
			.slice(window.location.href.indexOf('?') + 1)
			.split('&');
		for (var i = 0; i < hashes.length; i++) {
			hash = hashes[i].split('=');
			vars.push(hash[0]);
			vars[hash[0]] = hash[1];
		}
		return vars;
	}
	//form submission message
	function showSubmitted() {
		var submitted = urlParam()['form'];
		var id = urlParam()['id'];
		var type = urlParam()['type'];
		var url;

		switch (type) {
			//Application Amendment Form
			case 'staffAAR':
				url =
					'/employee_page/underwriting-rep-tools/search-application-amendment-requests/?preview=';
				break;
			case 'memberAAR':
				url =
					'/member/coverage-center/search-application-amendment-requests/?preview=';
				break;
		}

		if (submitted == 'submitted') {
			$('.form_preview').attr('href', url + id);
			$('.forms-message').fadeToggle('fast');
		}
		if (submitted == 'error') {
			$('.app-error-message').html(
				'There has been a submission error. Please contact CIRSA about the issue.',
			);
		}
	}

	function regMessage() {
		var submitted = urlParam()['reg'];
		if (submitted == 'submitted') {
			$('.forms-message').fadeToggle('fast');
		}
		if (submitted == 'error') {
			$('.reg-error-message').html(
				'There has been a submission error. Please contact CIRSA about the issue.',
			);
		}
	}

	function quoteMessage() {
		var submitted = urlParam()['quote'];
		if (submitted == 'submitted') {
			$('.request-a-quote-form').html(
				'<div class="quote-success-message">Thank you for requesting a quote.' +
					'<br>' +
					'We will be contacting you shortly.' +
					'<br>' +
					'<a class="btn" href="/">Home</a></div>',
			);
		}
		if (submitted == 'error') {
			$('.quote-error-message').html(
				'There has been a submission error. Please contact CIRSA about the issue.',
			);
		}
	}

	//get member data from db
	function memberDataForm() {
		// console.log('getting logged in member info');
		var form = $('input[name="cirsa_member_name"]').val();
		// console.log(form);
		jQuery.ajax({
			type: 'POST',
			url: '/wp-admin/admin-ajax.php',
			data: {
				action: 'member_data_form',
				//dataType: "JSON",
				data: form,
			},
			success: function (response) {
				//console.log(response);
				var res = JSON.parse(response);
				// console.log(res);
				return false;
				//using PHP for data

				if (res == 'no results') {
					$('.member-no-results').html('No search results found');
				} else {
					$('.member-no-results').html('');
					$('.forms-member-data').find('.member-data-value').html('');

					$('.md-code').html(res.entity.member_code);
					$('.md-name').html(res.entity.member_name);
					$('.md-phone').html(res.entity.phone);
					$('.md-alt-phone').html(res.entity.alt_phone);
					$('.md-fax').html(res.entity.fax);
					$('.md-website').html(res.contact.website);
					$('.md-address').html(res.entity.mailing_address_1);
					$('.md-address-2').html(res.entity.mailing_address_2);
					$('.md-city').html(res.entity.physical_city);
					$('.md-state').html(res.entity.physical_state);
					$('.md-zip').html(res.entity.physical_zip_code);

					// $('.md-lc-rep').html(res.loss_control_rep);
					// $('.md-lc-rep-email').html(res.loss_control_email);
					// $('.md-pc-rep').html(res.pc_claims_rep);
					// $('.md-pc-rep-email').html(res.pc_claims_email);
					// $('.md-wc-rep').html(res.wc_claims_rep);
					// $('.md-wc-rep-email').html(res.wc_claims_email);
					// $('.md-u-rep').html(res.uw_rep);
					// $('.md-u-rep-email').html(res.uw_email);
					// $('.md-ms-rep').html(res.membership_rep);
					// $('.md-ms-rep-email').html(res.membership_email);
					// if (res.pc_pool == 'Yes') {
					//     $('.md-prop-liab').prop('checked', true);
					// } else {
					//     $('.md-prop-liab').prop('checked', false);
					// }
					// if (res.wc_pool == 'Yes') {
					//     $('.md-comp-cov').prop('checked', true);
					// } else {
					//     $('.md-comp-cov').prop('checked', false);
					// }
					// var optional = res.optional_coverage.length;
					// if (optional > 0) {
					//     $('.md-comp-opt').prop('checked', true);
					//     $('.option-list').html(res.optional_coverage);

					// } else {
					//     $('.md-comp-opt').prop('checked', false);
					// }
					// $('.md-p-contact').html(res.prim_name);
					// $('.md-p-contact-title').html(res.prim_title);
					// $('.md-p-contact-email').html(res.prim_email);

					// $('.md-lc-contact').html(res.loss_name);
					// $('.md-lc-contact-title').html(res.loss_title);
					// $('.md-lc-contact-email').html(res.loss_email);

					// $('.md-upc-contact').html(res.uw_pc_name);
					// $('.md-upc-contact-title').html(res.uw_pc_title);
					// $('.md-upc-contact-email').html(res.uw_pc_email);

					// $('.md-uwc-contact').html(res.uw_wc_name);
					// $('.md-uwc-contact-title').html(res.uw_wc_title);
					// $('.md-uwc-contact-email').html(res.uw_wc_email);

					// $('.md-cpc-contact').html(res.pc_claim_contact_name);
					// $('.md-cpc-contact-title').html(res.pc_claim_contact_title);
					// $('.md-cpc-contact-email').html(res.pc_claim_contact_email);

					// $('.md-cwc-contact').html(res.wc_claim_contact_name);
					// $('.md-cwc-contact-title').html(res.wc_claim_contact_title);
					// $('.md-cwc-contact-email').html(res.wc_claim_contact_email);

					// $('.md-ap-contact').html(res.ap_name);
					// $('.md-ap-contact-title').html(res.ap_title);
					// $('.md-ap-contact-email').html(res.ap_email);

					// $('.md-voter').html(res.voter_name);
					// $('.md-voter-title').html(res.voter_title);
					// $('.md-voter-email').html(res.voter_email);

					// $('.md-alt-voter').html(res.alt_voter_name);
					// $('.md-alt-voter-title').html(res.alt_voter_title);
					// $('.md-alt-voter-email').html(res.alt_voter_email);

					// $('.md-city-mgmt').html(res.manager_name);
					// $('.md-city-mgmt-title').html(res.manager_title);
					// $('.md-city-mgmt-email').html(res.manager_email);

					// $('.md-mayor').html(res.mayor);
					// $('.md-mayor-email').html(res.mayor_email);
				}
			},
		});
	}

	//request member info change
	function memberDataChange() {
		$('#member-data-change').on('submit', function (e) {
			e.preventDefault();
			var md_serialized = $(this).serializeArray();
			//console.log(data);
			sendMemberDataChange(md_serialized);
		});
	}

	function sendMemberDataChange(md_serialized) {
		jQuery.ajax({
			type: 'POST',
			url: '/wp-admin/admin-ajax.php',
			data: {
				action: 'send_md_form',
				value: md_serialized,
			},
			success: function (response) {
				// console.log(response);
				//reset form
				$('#member-data-change').each(function () {
					this.reset();
				});
				$('.md-request-change').fadeToggle('fast');
				$('#member-data-change').fadeToggle('fast');
				$('.md-request-submitted').fadeToggle('fast');
			},
		});
	}

	//grab attachments on change
	function prepareUpload(event) {
		var files = event.target.files;
		// console.log(files);
		sendLossFiles(files);
	}
	//send attachments to backend
	function sendLossFiles(files) {
		var fdata = new FormData();

		$.each(files, function (key, value) {
			fdata.append(key, files[key]);
		});

		fdata.append('action', 'loss_control_files');

		jQuery.ajax({
			type: 'POST',
			url: '/wp-admin/admin-ajax.php',
			data: fdata,
			cache: false,
			processData: false,
			contentType: false,
			success: function (data) {
				var res = $.parseJSON(data);
				var count = 0;
				for (var i = res.length - 1; i >= 0; i--) {
					$.each(res[i], function (key, value) {
						$('#loss-control-form').append(
							'<input type="hidden" name="' +
								key +
								'_' +
								count +
								'" value="' +
								value +
								'">',
						);
						if (key == 'file_name') {
							$('.form-upload').append('<p>' + value + '</p>');
						}
					});
					count++;
				}
			},
			error: function (error) {
				var err = JSON.stringify(error);
				console.log('there has been an error: ' + err);
			},
		});
	}

	//clear attachment uploads
	function clearAttachment() {
		$('.receipt-attach').change(function () {
			$('.clear-file-receipt').fadeToggle();
		});
		$('.clear-file-receipt').click(function (e) {
			e.preventDefault();
			$('.receipt-attach').val('');
			$('.clear-file-receipt').fadeToggle();
			$('.form-upload').find('p').remove();
		});
	}
})(jQuery);
